export const resources = {
    type: {
        bool: {
            label: 'Boolean',
            hint: 'Boolean'
        },
        ref: {
            label: 'Reference',
            hint: 'Reference'
        },
        enum: {
            label: 'Enumeration',
            hint: 'Enumeration'
        },
        int: {
            label: 'Integer',
            hint: 'Integer'
        },
        float: {
            label: 'Float',
            hint: 'Float'
        },
        decimal: {
            label: 'Decimal',
            hint: 'Decimal'
        },
        money: {
            label: 'Money',
            hint: 'Money'
        },
        string: {
            label: 'String',
            hint: 'String'
        },
        text: {
            label: 'Text',
            hint: 'Text'
        },
        richstring: {
            label: 'Rich String',
            hint: 'Rich String'
        },
        richtext: {
            label: 'Rich Text',
            hint: 'Rich Text'
        },
        local_datetime: {
            label: 'Local Datetime',
            hint: 'Local Datetime'
        },
        local_date: {
            label: 'Local Date'
        },
        local_: {
            hint: 'Local Date'
        },
        local_time: {
            label: 'Local Time',
            hint: 'Local Time'
        },
        utc_datetime: {
            label: 'UTC Datetime',
            hint: 'UTC Datetime'
        },
        zoned_datetime: {
            label: 'Datetime with Time Zone',
            hint: 'Datetime with Time Zone'
        },
        duration: {
            label: 'Duration',
            hint: 'Duration'
        }
    }
};
